var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['NumbarPadOnscreenKeyboard']
  }, _vm._l(_vm.keyLayout, function (row) {
    return _c('div', {
      key: row.name,
      staticClass: "row"
    }, _vm._l(row.keys, function (key) {
      return _c('touch-key', {
        key: key.name,
        attrs: {
          "name": key.name,
          "character": key.character,
          "alt": key.alt,
          "shift": key.shift,
          "special": key.special,
          "hold-hand": key.hold,
          "row": row.name,
          "press": _vm.handleKeyDown,
          "release": _vm.handleKeyUp,
          "role": 'button',
          "tabIndex": 10
        }
      }, [_c('span', [_vm._v(_vm._s(key.character))])]);
    }), 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }